import {
  InsuranceCoverageSource,
  InsuranceMonitorConfiguration
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Whether any of a monitor configuration's coverages accepts evidence from the
 * given source — e.g. whether a Wingspan plan enrollment can satisfy the
 * requirement, or only an uploaded certificate.
 */
export const selectorIsAcceptedSourceTypeIncluded = ({
  acceptedSourceType,
  insuranceMonitorConfiguration
}: {
  acceptedSourceType: InsuranceCoverageSource;
  insuranceMonitorConfiguration?: InsuranceMonitorConfiguration;
}) =>
  insuranceMonitorConfiguration?.coverages?.some(coverage =>
    coverage.acceptedSourceTypes?.includes(acceptedSourceType)
  );
